const items = [
  "qualidade",
  "Produtos Congelados",
  "Ingredientes Selecionados",
  "sabor",
  "Receitas Exclusivas",
  "qualidade",
  "frescor",
  "Ingredientes Selecionados",
  "Eventos",
  "\u2013 CE",
  "qualidade",
  "Produção Própria",
  "Ingredientes Selecionados",
  "Eventos",
  "Fortaleza \u2013 CE",
  "qualidade",
  "Produção Própria",
  "Ingredientes Selecionados",
  "Eventos",
  "Fortaleza \u2013 CE",
];

export default function MarqueeStrip() {
  return (
    <section className="py-2 sm:py-3 bg-foreground-900 overflow-hidden border-y border-foreground-700/20">
      <div className="flex items-center gap-5 sm:gap-6 md:gap-8 whitespace-nowrap marquee-track">
        {items.map((text, idx) => (
          <div key={`${text}-${idx}`} className="flex items-center gap-5 sm:gap-6 md:gap-8 text-background-50">
            <span className="font-heading text-xs sm:text-sm md:text-base font-semibold tracking-tight uppercase whitespace-nowrap">
              {text}
            </span>
            <span className="text-primary-500 text-sm md:text-base">•</span>
          </div>
        ))}
      </div>
    </section>
  );
}